import React, {
  useState,
  useEffect
}                             from 'react';
import PropTypes              from 'prop-types';
import { useTranslation }     from 'react-i18next';
import QuestionAnswerIcon     from '@material-ui/icons/QuestionAnswer';

import Button                 from '~/components/Button';
import Request                from '~/providers/Request';
import useStyles              from './styles';
import Grid                   from '@material-ui/core/Grid';
import InputControl           from '~/components/Input/InputControl';
import InputTextEditor        from '~/components/Input/InputTextEditor';
import Input                  from '@material-ui/core/Input';
import { toast }              from 'react-toastify';
import InputCheckBox          from '~/components/Input/InputCheckBox';

import Dialog                 from '~/components/Dialog';
import InputNumber            from '~/components/Input/InputNumber';
import InputSelect            from '~/components/Input/InputSelect';

function ModalArticle(props) {
	const { modal, onClose, folders_list, isEdit, article, action } = props;
	const { t } = useTranslation();
	const trAttr = (attr) => t(`faq.attributes.${attr}`);
	const [listSelect, setListSelect] = useState(null);
	const initialState = {
		id: '',
		name: '',
		description: '',
		sorter: 0,
		folder: '',
		checkBox: false,
	};
	const [values, setValues] = useState(initialState);
	const classes = useStyles();

	const handleChangeInputControll = data => {
		setValues({ ...values, ...data });
	};

	const handleChangeJodit = name => event => {
		setValues({ ...values, [name]: event.description });
	};

	useEffect(() => {
		buildSelect();
		setValues({
			id: article.id ? article.id : '',
			name: article.title ? article.title : '',
			description: article.description ? article.description : '',
			sorter: article.sorter ? article.sorter : 0,
			folder: article.folder ? article.folder.id : '',
			checkBox: article.is_published ? article.is_published : false,
		});
	}, [article, folders_list]);

	async function saveAction() {
		const data = {
			attributes: {
				title: values.name,
				description: values.description,
				sorter: values.sorter,
				faq_folder_id: ((typeof values.folder === 'object') ? values.folder.id : values.folder),
				is_published: values.checkBox,
			}
		};
		if (!isEdit) {
			try {
				const resp = await Request.post('/admin/faq/articles', { data }, {}, { controller: 'faq' });
				if (action)
					action(resp.data);
				setValues(initialState);
				onClose();
				toast.success(t('faq.extras.save_article'));
			} catch (e) {
				console.log(e);
			}
		} else {
			try {
				const resp = await Request.put(`/admin/faq/articles/${article.id}`, {data}, {}, { controller: 'faq' });
				if (action)
					action(resp.data);
				setValues(initialState);
				onClose();
				toast.success(t('faq.extras.edit_article'));
			} catch (e) {
				console.log(e);
			}
		}
	}

	function buildSelect() {
		const array = [];
		folders_list && folders_list.map((category) => {
			category.folders.map((folder) => {
				array.push({ id: folder.id, name: `${category.name} - ${folder.name}` });
			});
		});
		setListSelect(array);
	}

	function handleClose(){
		onClose();
		setValues(initialState);
	}

	return (
		<Dialog
			icon={<QuestionAnswerIcon />}
			isOpen={modal}
			handleClose={handleClose}
			title={isEdit ? t('faq.extras.article_edit') : t('faq.extras.article_new')}
			dialogActions={
				<>
					<Button color='black' variant='text' onClick={handleClose} className={classes.button}>
						{t('form-cancel')}
					</Button>
					<Button color='success' variant='text' onClick={() => { saveAction(); }} className={classes.button}>
						{t('form-submit')}
					</Button>
				</>
			}
		>
			<InputControl
				value={values.name}
				name={'name'}
				label={trAttr('title')}
				inputComponent={Input}
				onChange={handleChangeInputControll}
			/>
			<InputControl
				id={'description'}
				value={values.description}
				onChange={handleChangeJodit('description')}
				name={'description'}
				inputComponent={InputTextEditor}
			/>
			<Grid container spacing={2}>
				<Grid item xs={6}>
					<InputControl
						value={values.folder}
						name={'folder'}
						label={trAttr('folder')}
						inputComponent={InputSelect}
						onChange={ handleChangeInputControll }
						InputProps={{
							options: listSelect
						}}
					/>
				</Grid>
				<Grid item xs={4}>
					<InputControl
						value={values.sorter}
						name={'sorter'}
						label={trAttr('sorter')}
						inputComponent={InputNumber}
						InputProps={{ precision: 0 }}
						onChange={handleChangeInputControll}
					/>
				</Grid>
				<Grid item xs={2}>
					<InputControl
						value={values.checkBox}
						name={'checkBox'}
						label={trAttr('is_active')}
						inputComponent={InputCheckBox}
						onChange={handleChangeInputControll}
					/>
				</Grid>
			</Grid>
		</Dialog>
	);
}

ModalArticle.propTypes = {
	modal: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	article: PropTypes.object.isRequired,
	folders_list: PropTypes.array.isRequired,
	isEdit: PropTypes.bool.isRequired,
	action: PropTypes.func,
};
export default ModalArticle;
